import { DEFAULT_MAP_LOCATION } from '@americanexpress/one-maps-base/lib/utils/MapCampaigns';
// eslint-disable-next-line complexity
function getTypeAheadRequestOneData(args, isOnline, locale, mleListId, apiKey) {
  const typeAheadRequest = {
    ...apiKey && { accountToken: apiKey },
    clientIdentifier: 'maps',
    channelIdentifier: '37',
    countryCode: isOnline ? 'US' : args.locationDetails.country,
    requestIdentifier: `maps${new Date().getTime()}`,
    locale: 'en-US', // request language only, does not impact results
    requestParams: {
      limit: 5,
      requestLocation: {
        geoCenter: {
          latitude: args.locationDetails.lat || DEFAULT_MAP_LOCATION[locale].lat,
          longitude: args.locationDetails.lng || DEFAULT_MAP_LOCATION[locale].lng,
        },
      },
      filterParams: {
        typeIdentifier: isOnline ? 'online' : 'instore',
        smallMerchantIndicator: true,
        largeMerchantIndicator: true,
        searchText: args.keyword,
      },
    },
  };

  // set the MLE List id in request
  if (mleListId) {
    typeAheadRequest
      .requestParams
      .filterParams
      .listIdentifier = mleListId;
  }

  // set merchant indicators = ALL for below 6 markets
  if (args.locationDetails && args.locationDetails.country
    && (args.locationDetails.country.toLowerCase() === 'mx' || args.locationDetails.country.toLowerCase() === 'sg'
      || args.locationDetails.country.toLowerCase() === 'it' || args.locationDetails.country.toLowerCase() === 'es'
      || args.locationDetails.country.toLowerCase() === 'de' || args.locationDetails.country.toLowerCase() === 'fr')) {
    typeAheadRequest
      .requestParams
      .filterParams
      .largeMerchantIndicator = true;
  }

  // set small merchant indicator = NO for NL market
  if (args.locationDetails && args.locationDetails.country && args.locationDetails.country.toLowerCase() === 'nl') {
    typeAheadRequest
      .requestParams
      .filterParams
      .smallMerchantIndicator = false;
  }

  // set small merchant indicator = YES for JP market
  if (args.locationDetails && args.locationDetails.country && args.locationDetails.country.toLowerCase() === 'jp') {
    typeAheadRequest
      .requestParams
      .filterParams
      .smallMerchantIndicator = true;
  }

  return typeAheadRequest;
}

// module.exports = getTypeAheadRequestOneData;
export default getTypeAheadRequestOneData;
